module.exports = __webpack_public_path__ + "media/images/landing/icon-group65-1679795a48394f95b04f215656c7c045.svg";